import { useQuery } from '@tanstack/react-query';
import { fetchContactByEmail } from '../services/ContactsService';

export const useContactByEmail = (email: string | undefined) => {
    const query = useQuery({
        queryKey: ['contact-by-email', email],
        queryFn: () => fetchContactByEmail(email!),
        enabled: !!email,
    });

    return {
        contact: query.data ?? null,
        loading: query.isLoading,
    };
};
